window.PH = window.PH || {};

PH.taxonomy = {
  version: '1.0.0',

  families: {
    fresco: ['fresco', 'fresh', 'limpio', 'clean'],
    citrico: ['citrico', 'cítrico', 'citrus', 'limon', 'bergamota', 'naranja', 'mandarina'],
    acuatico: ['acuatico', 'acuático', 'marino', 'oceanico', 'oceánico', 'agua', 'playa'],
    amaderado: ['amaderado', 'madera', 'cedro', 'sandalwood', 'sándalo'],
    dulce: ['dulce', 'sweet', 'vainilla', 'caramelo', 'praline', 'praliné'],
    floral: ['floral', 'flores', 'jazmin', 'jazmín', 'rosa', 'iris'],
    ambar: ['ambar', 'ámbar', 'amber', 'resinoso'],
    cuero: ['cuero', 'leather', 'piel'],
    especiado: ['especiado', 'spicy', 'pimienta', 'cardamomo', 'canela'],
    gourmand: ['gourmand', 'chocolate', 'cacao', 'cafe', 'café'],
    frutal: ['frutal', 'frutas', 'piña', 'manzana', 'pera', 'durazno']
  },

  occasions: {
    oficina: ['oficina', 'trabajo', 'junta', 'reunion', 'reunión', 'formal', 'ejecutivo'],
    cita: ['cita', 'romantico', 'romántico', 'ligar', 'date', 'seductor'],
    noche: ['noche', 'fiesta', 'antro', 'bar', 'salida'],
    diario: ['diario', 'dia', 'día', 'casual', 'uso diario'],
    playa: ['playa', 'vacaciones', 'mar', 'cancun', 'cancún'],
    evento: ['evento', 'boda', 'graduacion', 'graduación', 'ocasion especial', 'ocasión especial'],
    gym: ['gym', 'gimnasio', 'deporte', 'entrenar']
  },

  climates: {
    calor: ['calor', 'verano', 'merida', 'mérida', 'yucatan', 'yucatán', 'clima caliente'],
    frio: ['frio', 'frío', 'invierno', 'clima frio', 'clima frío'],
    templado: ['templado', 'primavera', 'otoño']
  },

  moods: {
    elegante: ['elegante', 'sofisticado', 'premium', 'lujoso'],
    limpio: ['limpio', 'clean', 'fresco'],
    seductor: ['seductor', 'sexy', 'atractivo', 'ligar'],
    juvenil: ['juvenil', 'joven', 'divertido'],
    intenso: ['intenso', 'potente', 'fuerte', 'presencia'],
    versatil: ['versatil', 'versátil', 'todo terreno', 'facil de usar', 'fácil de usar']
  },

  gender: {
    caballero: ['caballero', 'hombre', 'masculino'],
    dama: ['dama', 'mujer', 'femenino'],
    unisex: ['unisex', 'compartido']
  },

  normalize(text) {
    return String(text || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9\s]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  },

  matchGroup(text, group) {
    const clean = this.normalize(text);

    return Object.keys(group).filter(key => {
      return group[key].some(term => clean.includes(this.normalize(term)));
    });
  },

  analyzeText(text) {
    return {
      families: this.matchGroup(text, this.families),
      occasions: this.matchGroup(text, this.occasions),
      climates: this.matchGroup(text, this.climates),
      moods: this.matchGroup(text, this.moods),
      gender: this.matchGroup(text, this.gender)
    };
  }
};